/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'noshow': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(8 8)" _stroke="#00272E"><circle pid="0" cx="8.5" cy="8.5" r="8.146"/><path pid="1" d="M2.74 14.26L14.26 2.74"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/noshow.js